import { createProductKeyModel, ProductKeyModel } from "./ProductModel";

export interface ProductPickerModel {
    inStock: boolean;
    name: string;
}

export interface CodePickerModel extends ProductPickerModel {
    product: ProductKeyModel;
}

export interface SizePickerModel extends ProductPickerModel {
    codes: CodePickerModel[];
}

export interface LinePickerModel extends ProductPickerModel {
    id: number;
    imageUrl: string;
    sizes: SizePickerModel[];
}

export const createProductPickerModel = (): ProductPickerModel => ({
    inStock: false,
    name: ""
});

export const createCodePickerModel = (): CodePickerModel => ({
    inStock: false,
    name: "",
    product: createProductKeyModel()
});

export const createSizePickerModel = (): SizePickerModel => ({
    inStock: false,
    name: "",
    codes: []
});

export const createLinePickerModel = (): LinePickerModel => ({
    inStock: false,
    name: "",
    id: 0,
    imageUrl: "",
    sizes: []
});